import * as delProjectValidation from "./delProjectValidation";
import * as delEmployeeValidation from "./delEmployeeValidation";
import * as delUnitValidation from "./delUnitsValidation";
import * as delFieldNotesValidation from "./delFieldNotesValidation";
import * as delClientSignatureValidation from "./delClientSignatureValidation";
import * as delJsaV1Validation from "./delJsaV1Validation";
import * as delJsaV2Validation from "./delJsaV2Validation";
import * as delWasteDisposalValidation from "./delWasteDisposalValidation";

// Putting all the validation functions together to pass on to the DEL class
export const validateDraftDel = (del, delMode) => {
  const errors = {
    projectInfo: null,
    employees: null,
    units: null,
    miscUnits: null,
    rentalUnits: null,
    projectSpecificUnits: null,
    fieldNotes: null,
    clientSignatures: null,
    jsa: null,
    wasteDisposal: null,
  };

  // Validating the project info
  const projectErrors = delProjectValidation.validateDraftDelProject(
    del.projectInfo,
    delMode
  );

  if (projectErrors) {
    errors.projectInfo = projectErrors;
  }

  // Validating the employees
  const employeeErrors = delEmployeeValidation.validateDraftDelEmployees(
    del.employees
  );

  if (employeeErrors) {
    errors.employees = employeeErrors;
  }

  // Validating the units
  const unitErrors = delUnitValidation.validateDraftDelUnits(del.units);

  if (unitErrors) {
    errors.units = unitErrors;
  }

  // Validating the misc units
  const miscUnitErrors = delUnitValidation.validateDraftMiscEquipment(
    del.miscUnits
  );

  if (miscUnitErrors) {
    errors.miscUnits = miscUnitErrors;
  }

  // Validating the rental units
  const rentalUnitErrors = delUnitValidation.validateDraftRentalEquipment(
    del.rentalUnits
  );

  if (rentalUnitErrors) {
    errors.rentalUnits = rentalUnitErrors;
  }

  // Validating the project-specific units
  if (del.projectSpecificUnits && del.projectSpecificUnits.length > 0) {
    const projectSpecificUnitErrors =
      delUnitValidation.validateDraftProjectSpecificUnits(
        del.projectSpecificUnits
      );
    if (projectSpecificUnitErrors && projectSpecificUnitErrors.length > 0) {
      errors.projectSpecificUnits = projectSpecificUnitErrors;
    }
  }

  // Validating the field notes
  const fieldNotesErrors = delFieldNotesValidation.validateDraftFieldNotes(
    del.fieldNotes.activities
  );

  if (fieldNotesErrors) {
    errors.fieldNotes = fieldNotesErrors;
  }

  let clientSignatureErrors = null;
  // Validating the client signatures if we the client signatures is checked
  if (del.projectInfo.clientSignaturesChecked) {
    clientSignatureErrors =
      delClientSignatureValidation.validateDelClientSignaturesDraft(
        del.clientSignatures
      );
  }

  if (clientSignatureErrors) {
    errors.clientSignatures = clientSignatureErrors;
  }

  // Validating the JSA, but first checking if it is V1 or V2
  let jsaErrors = null;
  if (!del.projectInfo.jsaNotRequired) {
    if (del.projectInfo.jsaVersion === 1) {
      console.log("JSA V1:", del.jsa);
      jsaErrors = delJsaV1Validation.validateJsaV1DelDraft(del.jsa);
    } else if (del.projectInfo.jsaVersion === 2) {
      console.log("JSA V2:", del.jsa);
      jsaErrors = delJsaV2Validation.validateJsaV2Draft(del.jsa);
    }
  }

  console.log("JSA Errors in DEL Validation:", jsaErrors);
  if (jsaErrors) {
    errors.jsa = jsaErrors;
  }

  // Validating the waste disposal
  if (!del.projectInfo.wasteDisposalNotRequired) {
    const wasteDisposalErrors =
      delWasteDisposalValidation.validateWasteDisposal(del.wasteDisposal);

    if (wasteDisposalErrors) {
      errors.wasteDisposal = wasteDisposalErrors;
    }
  }

  return errors;
};

// Validating the DEL Submitted
export const validateDelSubmitted = (del, delMode) => {
  const errors = {
    projectInfo: null,
    employees: null,
    units: null,
    miscUnits: null,
    rentalUnits: null,
    projectSpecificUnits: null,
    fieldNotes: null,
    clientSignatures: null,
    jsa: null,
    wasteDisposal: null,
  };

  // For approval mode, use stricter project validation
  if (delMode === "approve") {
    const projectErrors = delProjectValidation.validateApprovedDelProject(
      del.projectInfo
    );
    if (projectErrors && Object.keys(projectErrors).length > 0) {
      errors.projectInfo = projectErrors;
    }
  } else {
    // Validating the project info for submit
    const projectErrors = delProjectValidation.validateSubmittedDelProject(
      del.projectInfo,
      delMode
    );
    if (projectErrors && Object.keys(projectErrors).length > 0) {
      errors.projectInfo = projectErrors;
    }
  }

  // Check for at least one employee
  if (!del.employees || del.employees.length === 0) {
    errors.employees = [
      {
        employeeRowId: null,
        errors: {
          general: "At least one Employee is required",
        },
      },
    ];
  } else {
    // Validating the employees
    const employeeErrors = delEmployeeValidation.validateSubmittedDelEmployees(
      del.employees
    );
    if (employeeErrors && employeeErrors.length > 0) {
      errors.employees = employeeErrors;
    }
  }

  // Check for at least one unit
  if (!del.units || del.units.length === 0) {
    errors.units = [
      {
        unitRowId: null,
        errors: {
          general: "At least one Unit is required",
        },
      },
    ];
  } else {
    // Validating the units
    const unitErrors = delUnitValidation.validateSubmittedDelUnits(del.units);
    if (unitErrors && unitErrors.length > 0) {
      errors.units = unitErrors;
    }
  }

  // Validating the misc units
  const miscUnitErrors = delUnitValidation.validateSubmittedMiscEquipment(
    del.miscUnits
  );
  if (miscUnitErrors && miscUnitErrors.length > 0) {
    errors.miscUnits = miscUnitErrors;
  }

  // Validating the rental units
  const rentalUnitErrors = delUnitValidation.validateSubmittedRentalEquipment(
    del.rentalUnits
  );
  if (rentalUnitErrors && rentalUnitErrors.length > 0) {
    errors.rentalUnits = rentalUnitErrors;
  }

  // Validating the project-specific units
  if (del.projectSpecificUnits && del.projectSpecificUnits.length > 0) {
    const projectSpecificUnitErrors =
      delUnitValidation.validateSubmittedProjectSpecificUnits(
        del.projectSpecificUnits
      );
    if (projectSpecificUnitErrors && projectSpecificUnitErrors.length > 0) {
      errors.projectSpecificUnits = projectSpecificUnitErrors;
    }
  }

  // Validating the field notes
  const fieldNotesErrors = delFieldNotesValidation.validateSubmittedFieldNotes(
    del.fieldNotes.activities
  );

  if (fieldNotesErrors && fieldNotesErrors.length > 0) {
    errors.fieldNotes = fieldNotesErrors;
  }

  // Validating the client signatures if we the client signatures is checked
  let clientSignatureErrors = null;
  if (del.projectInfo.clientSignaturesChecked) {
    clientSignatureErrors =
      delClientSignatureValidation.validateDelClientSignaturesSubmitted(
        del.clientSignatures
      );
  }

  if (clientSignatureErrors && clientSignatureErrors.length > 0) {
    errors.clientSignatures = clientSignatureErrors;
  }

  // Validating the JSA
  let jsaErrors = null;
  if (!del.projectInfo.jsaNotRequired) {
    if (del.projectInfo.jsaVersion === 1) {
      console.log("JSA V1:", del.jsa);
      jsaErrors = delJsaV1Validation.validateJsaV1DelSubmitted(del.jsa);
    } else if (del.projectInfo.jsaVersion === 2) {
      console.log("JSA V2:", del.jsa);
      jsaErrors = delJsaV2Validation.validateJsaV2DelSubmitted(del.jsa);
    }
  }

  if (jsaErrors) {
    errors.jsa = jsaErrors;
  }

  // Validating the waste disposal
  const wasteDisposalErrors = delWasteDisposalValidation.validateWasteDisposal(
    del.wasteDisposal
  );
  if (wasteDisposalErrors) {
    errors.wasteDisposal = wasteDisposalErrors;
  }
  console.log("Errors in DEL Validation:", errors);
  return errors;
};
